module.exports = __webpack_public_path__ + "img/MoonSword 3b.205553d6.png";